import { Modal } from 'antd'
import { breakpoints, colors } from 'style'
import styled from 'styled-components'

export const ImageCropperContainer = styled(Modal)`
  .cropper-container {
    position: relative;
    width: 97.5%;
    height: 38.5vh;
  }
  .cropper-control {
    display: flex;
    align-items: center;
    width: 60%;
    margin-left: auto;
    margin-right: auto;
    // border-bottom: 1px solid #f2f2f2;
    button {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 34px;
      height: 34px;
      padding: 0;
      font-style: normal;
      background: transparent;
      border: 0;
      outline: 0;
      cursor: pointer;
      &[disabled] {
        cursor: default;
      }
    }
    &.zoom button {
      font-size: 18px;
    }
    &.rotate button {
      font-size: 16px;
      &:first-of-type {
        transform: rotate(-20deg);
      }
      &:last-of-type {
        transform: rotate(20deg);
      }
    }
    .ant-slider {
      flex: 1;
      margin: 0 8px;
    }
  }

  .hor-ver-control {
    display: flex;
    align-items: center;
    width: 55%;
    margin-left: auto;
    margin-right: auto;
  }

  @media (max-width: ${breakpoints.xl}px) {
  }

  // Here modal style...
  .ant-modal-content {
    .ant-modal-close {
      color: white !important;
      margin-top: -3.5px;
    }

    .ant-modal-header {
      background-color: #4c4c4c;

      .ant-modal-title {
        color: white !important;
      }
    }

    .ant-modal-body {
      background-color: #f4f3f3;
    }

    .modal-custom-body {
      background-color: white;
      border-radius: 15px;

      h4 {
        text-align: center !important;
      }
    }

    .p20 {
      padding: 20px !important;
    }

    .mb-20 {
      margin-bottom: 20px !important;
    }

    .mt-20 {
      margin-top: 20px !important;
    }

    .modal-custom-footer {
      padding: 24px 0 0 0 !important;

      .actions {
        padding: 8px 0 !important;

        .green {
          background-color: #4e9e69 !important;
          border-color: #4e9e69 !important;
          color: white !important;
        }

        .gray {
          background-color: #4c4c4c !important;
          border-color: #4c4c4c !important;
          color: white !important;
        }
      }
    }

    .ant-modal-footer {
      padding: 10px 20px !important;
      background: #f4f3f3 !important;

      .ant-btn {
        background-color: rgb(255, 255, 255);
        color: rgb(0, 0, 130);
        border: 2px solid rgb(0, 0, 130);
        border-radius: 5px;

        &:hover,
        &:active,
        &:focus-visible,
        &:focus {
          background-color: ${colors.blueDark};
          color: ${colors.white};
          border: 2px solid ${colors.blueDark};
        }
      }

      .ant-btn.ant-btn-primary {
        background-color: ${colors.blueDark};
        border-color: ${colors.blueDark};
        color: white;

        &:hover,
        &:active,
        &:focus-visible,
        &:focus {
          background-color: ${colors.white};
          color: ${colors.blueDark};
          border: 2px solid ${colors.blueDark};
        }
      }
    }
  }
`
